export default __webpack_public_path__ + "static/media/OTEL_Bg-Loop.b5b17071.mp4";